const comMeta = { lang: 'zh' }

const H5 = [
  {
    path: '/h5',
    name: `h5`,
    redirect: { path: '/h5/all' },
    component: () => import('@/views/h5/index'),
    meta: {
      ...comMeta,
      title: '华盟·税纪云',
      metaInfo: {
        title: '华盟·税纪云'
      }
    },
    children: [
      {
        path: 'all',
        name: `h5-all`,
        component: () => import('@/views/h5/index'),
        meta: {
          ...comMeta,
          title: '华盟·税纪云',
          metaInfo: {
            title: '华盟·税纪云'
          }
        }
      },
      {
        path: 'CIT',
        name: `h5-CIT`,
        component: () => import('@/views/h5/index'),
        meta: {
          ...comMeta,
          title: '华盟·税纪云',
          metaInfo: {
            title: '华盟·税纪云'
          }
        }
      },
      {
        path: 'IIT',
        name: `h5-IIT`,
        component: () => import('@/views/h5/index'),
        meta: {
          ...comMeta,
          title: '华盟·税纪云',
          metaInfo: {
            title: '华盟·税纪云'
          }
        }
      },
      {
        path: 'law',
        name: `h5-law`,
        component: () => import('@/views/h5/index'),
        meta: {
          ...comMeta,
          title: '华盟·税纪云',
          metaInfo: {
            title: '华盟·税纪云'
          }
        }
      },
      {
        path: 'ETR',
        name: `h5-ETR`,
        component: () => import('@/views/h5/index'),
        meta: {
          ...comMeta,
          title: '华盟·税纪云',
          metaInfo: {
            title: '华盟·税纪云'
          }
        }
      }
    ]
  }
]

export default H5



// WEBPACK FOOTER //
// ./src/router/modules/h5.js